
import { computed, defineComponent, reactive } from 'vue'

// components
import Modal from '@/common/components/UI/Modal/index.vue'
import TheSelect from '@/common/components/UI/TheSelect/index.vue'
import FileReader from '@/common/components/UI/FileReader/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

// validation
import useVuelidate from '@vuelidate/core'
import { requiredIf } from '@vuelidate/validators'

// constants
import { FLIGHT_DEPARTURES_STATUSES } from '@/core/constants/flight_departures.constants'

export default defineComponent({
    components: {
        Modal,
        FileReader,
        TheSelect,
        TheButton,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        isUpdate: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update', 'create', 'cancel'],
    setup(props, { emit }) {
        const state = reactive({
            files: [] as File[],
            status: null as number | null,
        })

        const state_form$ = useVuelidate(
            {
                files: { required: requiredIf(() => !props.isUpdate) },
                status: { required: requiredIf(() => props.isUpdate) },
            },
            state
        )

        const emitUpdate = () => {
            emit('update', state.status)
        }

        const emitCreate = () => {
            emit('create', state.files)
        }

        const emitCancel = () => {
            emit('cancel')
        }

        const emitManager = () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            if (props.isUpdate) {
                emitUpdate()
            } else {
                emitCreate()
            }
        }

        const getTitle = computed(() =>
            props.isUpdate ? 'Редактировать график' : 'Добавить график'
        )

        return {
            state,
            state_form$,
            emitManager,
            emitCancel,
            //
            getTitle,
            //
            FLIGHT_DEPARTURES_STATUSES,
        }
    },
})
